import classNames from 'classnames';
import styles from './Welcome.module.css';
import { TOPIX_URL } from 'src/app/constants';

const Welcome = () => {
  return (
    <div className={classNames(styles.WelcomePage)}>
      <div className={classNames(styles['Welcome--PageTopicContainer'])}>
        <div className={classNames(styles['Welcome--TopicNotesContainer'])}>
          <p style={{ margin: '0px 0px 10px 0px' }}>
            TOPIx details are now available to view in VFDB
          </p>
          <p style={{ margin: '0px 0px 10px 0px' }}>
            TOPIx data is not available for download through VFDB currently, but can be downloaded
            via &nbsp;
            <a href={TOPIX_URL} target="_blank" rel="noreferrer" style={{ color: '#0073DD' }}>
              topix.jaguar.jlrext.com
            </a>
          </p>
        </div>
      </div>
      <div className={classNames(styles['Welcome--Headline'])}>
        <span>Welcome</span>
      </div>
      <div className={classNames(styles['Welcome--PageContent'])}>
        <div>
          To the next generation of VFDB.<br></br>
          <br></br>
          We are thrilled to have you explore our new system. Your feedback is invaluable to us.
          Please share your thoughts by clicking on the question mark icon in the top right corner.
          you can also use this option to report any bugs. <br></br>
          <br></br>
          Thank you for helping us improve, <br></br>
          <br></br>
          The VFDB Team <br></br>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
